import { CssReset } from "./reset";
import App from "./app";

export default { CssReset, ...App };
